<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.33464 2.17383C6.03345 2.17383 4.16797 4.03931 4.16797 6.3405C4.16797 8.64168 6.03345 10.5072 8.33464 10.5072C10.6358 10.5072 12.5013 8.64168 12.5013 6.3405C12.5013 4.03931 10.6358 2.17383 8.33464 2.17383ZM5.83464 6.3405C5.83464 4.95978 6.95392 3.84049 8.33464 3.84049C9.71535 3.84049 10.8346 4.95978 10.8346 6.3405C10.8346 7.72121 9.71535 8.8405 8.33464 8.8405C6.95392 8.8405 5.83464 7.72121 5.83464 6.3405Z"
      :fill="decideColor"
    />
    <path
      d="M8.33464 12.1738C8.33464 11.7136 7.95967 11.335 7.50296 11.3919C4.21356 11.8012 1.66797 14.6069 1.66797 18.0072C1.66797 18.4674 2.04106 18.8405 2.5013 18.8405H7.5013C7.96154 18.8405 8.33464 18.4674 8.33464 18.0072C8.33464 17.5469 7.96154 17.1738 7.5013 17.1738H3.40377C3.75523 15.0789 5.4094 13.4257 7.50482 13.0757C7.95877 12.9999 8.33464 12.6341 8.33464 12.1738Z"
      :fill="decideColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0013 13.0072C10.0013 11.6265 11.1206 10.5072 12.5013 10.5072H15.8346C17.2153 10.5072 18.3346 11.6265 18.3346 13.0072V16.3405C18.3346 17.7212 17.2153 18.8405 15.8346 18.8405H12.5013C11.1206 18.8405 10.0013 17.7212 10.0013 16.3405V13.0072ZM12.5013 12.1738C12.0411 12.1738 11.668 12.5469 11.668 13.0072V16.3405C11.668 16.8007 12.0411 17.1738 12.5013 17.1738H15.8346C16.2949 17.1738 16.668 16.8007 16.668 16.3405V13.0072C16.668 12.5469 16.2949 12.1738 15.8346 12.1738H15.0013V13.0072C15.0013 13.4674 14.6282 13.8405 14.168 13.8405C13.7077 13.8405 13.3346 13.4674 13.3346 13.0072V12.1738H12.5013Z"
      :fill="decideColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String, // active (red), inactive (grey), filled (white)
      required: false,
      default: 'inactive'
    }
  },
  computed: {
    decideColor() {
      if (this.color === 'inactive') {
        return '#4D4D4D'
      } else if (this.color === 'active') {
        return '#B82025'
      } else {
        return '#FFFFFF'
      }
    }
  }
}
</script>

